import * as React from 'react';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from './ui/sidebar';
import { NavMain } from './nav-main';
import { NavModules } from './nav-projects';
import { NavSecondary } from './nav-secondary';
import { NavUser } from './nav-user';
import { ProjectSwitcher } from './project-switcher';
import { useNavGroups } from '@/hooks/useNavGroups';
import { globalNavRoutesDef, companyNavRoutesDef } from '@/modules/app/routes';
import { useCan } from '@/hooks/useRbac';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const canSeeModules = useCan('sidebar:Modules');
  const globalGroups = useNavGroups(globalNavRoutesDef);
  const companyGroups = useNavGroups(companyNavRoutesDef);
  const groups = [...globalGroups, ...companyGroups];

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <ProjectSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <NavMain groups={groups} />
        {canSeeModules && <NavModules />}
        <NavSecondary className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
